import React from "react";

export default function Dot(props: any) {
  return (
    <svg
      width={props.width || 5}
      height={props.height || 5}
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={2.5} cy={2.5} r={2.5} fill={props.fill || "#FF752C"} />
    </svg>
  );
}
